<template>
  <div class="one-implement">
    <div>
      <!-- 头部 -->
      <div v-if="Object.keys(userData).length" class="one-implement-head">
        <!-- 人员信息 -->
        <div class="one-implement-top">
          <el-image class="implement-image" shape="square" fit="cover" :src="(userData && userData.ImgUrl) || avatar"></el-image>
          <div class="implement-main">
            <div class="implement-message">
              <span class="name">{{ userData && userData.Name }}</span>
              <span class="level">{{ userData && userData.CareLevel }}</span>
              <span class="room">房号: {{ userData && userData.Room }} </span>
            </div>
            <div class="implement-num">
              <div class="implement-all-check">
                <i class="el-icon-check"></i>
              </div>
              <span>执行</span>
              <span v-if="userData">（{{ userData.TotalCare - userData.NotExecuted }}/{{ userData.TotalCare }}）</span>
            </div>
          </div>
        </div>
      </div>

      <!--筛选--- 批量执行 -->
      <div class="implement-filter">
        <CommonFilter v-if="!userId" @click="openFilter(true)" @change="filterData"></CommonFilter>
        <div class="btn-list" v-if="implementType == 1 && showBtn">
          <div @click="openDialog(false)" class="all-btn all-cancel" type="primary" plain>全部取消</div>
          <div @click="openDialog(true)" class="all-btn all-sure" type="primary" plain>全部确认</div>
        </div>
      </div>

      <!-- tab切换 -->
      <div :class="['implement-row']">
        <div @click="tabChange(1)" :class="[implementType == 1 ? 'active-implement' : '', 'already-implement']">未执行</div>
        <div @click="tabChange(2)" :class="[implementType == 2 ? 'active-implement' : '', 'not-implement']">已执行</div>
      </div>
    </div>

    <!-- 列表 -->
    <div class="implement-list" v-if="mendicineList.length">
      <div class="implement-item" :id="'lv-list' + index" v-for="(item, index) in mendicineList" :key="item.Id">
        <div v-if="userId" class="time">{{ item.DTime && item.DTime.replace('T', ' ') }}</div>
        <implementItemHeader v-else :name="item.ProfileName" :avatar="item.ImgUrl" :time="item.DTime && item.DTime.replace('T', ' ')" :room="item.RoomNo"></implementItemHeader>
        <div class="line"></div>
        <div class="task-container">
          <el-image class="img" :src="timePhoto"></el-image>
          <div class="task" style="margin-right: auto">
            <span>{{ item.DrugName }}</span>
            <span>({{ item.FrequencyType }} )</span>
          </div>
          <div v-if="item.Value === '0'" class="task">{{ item.Amount }}/{{ item.Unit }}</div>
        </div>

        <div class="footer">
          <!-- 已执行 -->
          <div v-if="item.IsCheck" class="result" :style="{ color: item.Value == 0 ? '#029FD1' : '#F22D2E' }">
            <div v-if="item.Value === '0'">完成-</div>
            <div v-else>{{ (statusList[item.Value - 0 - 1] && statusList[item.Value - 0 - 1].text) || '' }}-</div>
            <div class="time-message">
              <div>于{{ item.InputDate }}由{{ item.CUser }}</div>
              <div v-if="item.Remark" class="remark">{{ item.Remark }}</div>
            </div>
          </div>

          <!-- 未执行 -->
          <div class="handle-btn" v-else>
            <div class="check-close">
              <el-image v-if="item.Value === 0" @click="allConfig(item)" class="img img-check" :src="require('@/assets/imgs/icon-zhuangtai-wancheng-2.png').default"></el-image>
              <el-image v-else @click="allConfig(item)" class="img img-check" :src="require('@/assets/imgs/icon-zhuangtai-wancheng-1.png').default"></el-image>
              <el-image @click="openRemark(item, true)" v-if="item.Value" class="img" :src="require('@/assets/imgs/icon-zhuangtai-weiwancheng-2.png').default"></el-image>
              <el-image @click="openRemark(item, true)" v-else class="img" :src="require('@/assets/imgs/icon-zhuangtai-weiwancheng-1.png').default"></el-image>
            </div>
            <el-image class="img" @click="openRemark(item, false)" :src="item.MedicalRecords.length > 0 ? jilu2 : jilu1"></el-image>
          </div>
        </div>
      </div>
    </div>
    <tips v-else></tips>
    <!-- 全选弹框-->
    <myDialog
      :dialogVisible="dialogVisible"
      :question="question ? '是否确认所有记录(不包含未来时间点的项目)？' : '是否确认全部取消？'"
      @close="dialogVisible = false"
      @setup="allConfig"
      dialogWidth="66%"
    ></myDialog>

    <el-pagination
      background
      class="pagination"
      :current-page="currentPage"
      :page-size="pagesize"
      :pager-count="5"
      layout="total,  prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange"
    />

    <!-- 说明弹框 -->
    <el-dialog class="implement-remark dialog" width="92%" :visible.sync="remarkDialog" :show-close="false" :close-on-click-modal="false" :close-on-press-escap="false" :destroy-on-close="true">
      <div class="implement-dialog">
        <div class="message">
          <div>{{ remarkDetail.type ? '未完成”时输入数值' : '添加说明信息' }}</div>
          <el-image @click="remarkDialog = false" class="close-image" :src="closebtn"></el-image>
        </div>

        <div class="task-name">
          <div class="task-container" style="margin: 0">
            <el-image class="task-image" :src="timePhoto"></el-image>
            <div class="task">{{ remarkDetail.DrugName }} {{ remarkDetail.MedicalCondition ? '- ' + remarkDetail.MedicalCondition : '' }}</div>
          </div>
          <div class="avatar-container">
            <el-image class="avatar-image" fit="cover" :src="remarkDetail.ImgUrl || avatar"></el-image>
            <div class="name">{{ remarkDetail.ProfileName }}</div>
          </div>
        </div>

        <div v-if="remarkDetail.type" class="select">
          <el-button
            @click="statusChange(item.status)"
            :class="['select-button', item.status == remarkDetail.Value ? 'active-buton' : '']"
            v-for="item in statusList"
            :key="item.text"
            type="primary"
            plain
          >
            {{ item.text }}
          </el-button>
        </div>

        <div>
          <p class="illustrate">说明:</p>
          <el-input class="textarea" type="textarea" resize="none" placeholder="请输入..." v-model="remarkDetail.Remark"> </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="submit" type="primary" @click="confirmRemark">确 认</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import myDialog from '@/common/dialog.vue'
import tips from '@/common/tips.vue'
import CommonFilter from '@/common/common-filter.vue'
import implementItemHeader from '@/common/implement-item-header.vue'

import avatar from '@/assets/imgs/avatar.png'
import timePhoto from '@/assets/imgs/time.png'
import jilu1 from '@/assets/imgs/icon-caozuo-jilu-1.png'
import jilu2 from '@/assets/imgs/icon-caozuo-jilu-2.png'
import closebtn from '@/assets/imgs/close.png'

export default {
  props: {
    userList: {
      type: Object,
      default: () => {}
    },
    userId: {
      type: String,
      default: ''
    }
  },
  // 局部注册的组件
  components: {
    CommonFilter,
    implementItemHeader,
    myDialog,
    tips
  },
  // 组件状态值
  data() {
    return {
      list: [],
      roomArr: [],
      userData: {},
      remarkDetail: {},
      currentPage: 1,
      pagesize: 15,
      total: 0,
      remarkDialog: false,
      dialogVisible: false,
      question: true,
      implementType: 1,
      avatar,
      jilu1,
      jilu2,
      timePhoto,
      closebtn,
      statusList: [
        {
          text: '拒绝',
          status: 1
        },
        {
          text: '缺席',
          status: 2
        },
        {
          text: '没有必要',
          status: 3
        },
        {
          text: '未完成',
          status: 4
        },
        {
          text: '延期',
          status: 5
        }
      ]
    }
  },

  watch: {
    userId: {
      handler(newName, oldName) {
        console.log('list-id')
        this.initData()
      },
      immediate: true
    },
    userList: {
      handler(newName, oldName) {
        console.log('list')
        this.initData()
      }
    }
  },

  computed: {
    showBtn() {
      return !this.$store.state.isScanCode || this.$store.state.scanCode === this.userId
    },

    // tab切换
    mendicineList() {
      let resultData = []
      if (this.implementType === 1) {
        resultData = this.list.filter((item) => !item.IsCheck)
      } else {
        resultData = this.list.filter((item) => item.IsCheck)
      }
      if (this.roomArr.length) {
        resultData = resultData.filter((val) => this.roomArr.find((el) => el === val.RoomNo))
      }
      this.total = resultData.length
      // 分页
      return resultData.slice((this.currentPage - 1) * this.pagesize, (this.currentPage - 1) * this.pagesize + this.pagesize)
    }
  },

  methods: {
    initData() {
      const arr = JSON.parse(JSON.stringify(this.userList))
      this.currentPage = 1
      this.implementType = 1
      // id单个人执行
      if (this.userId) {
        this.list = arr.Items.filter((item) => item.ProfileId === this.userId)
        this.userData = arr.ElderlyCares.find((item) => item.Id === this.userId)
      } else {
        // 批量执行
        this.list = arr.Items
        this.userData = {}
      }
    },
    tabChange(val) {
      this.currentPage = 1
      this.implementType = val
    },
    //  打开全选/全不选弹框-------------------------
    openDialog(val) {
      this.dialogVisible = true
      this.question = val
    },

    // 全选/全不选
    allConfig(val) {
      // 单选
      if (val) {
        val.Value = val.Value === 0 ? null : 0
        val.IsEdit = val.IsEdit ? 0 : 1
      } else {
        // 全选
        this.list.forEach((item) => {
          if (!item.IsCheck && new Date(item.DTime).getTime() < new Date().getTime()) {
            item.Value = this.question ? 0 : null
            item.IsEdit = this.question ? 1 : 0
          }
        })
      }
    },

    // 切换未完成状态
    statusChange(val) {
      this.remarkDetail.Value = val
    },

    //打开说明/未完成 弹窗--------------------------------------
    openRemark(val, type) {
      this.remarkDetail = { ...val, type }
      if (type) this.remarkDetail.Value = this.remarkDetail.Value || 4
      this.remarkDialog = true
    },

    // 说明/未完成 确定
    confirmRemark() {
      this.list.forEach((item) => {
        if (item.Id === this.remarkDetail.Id) {
          item.Value = this.remarkDetail.Value
          item.Remark = this.remarkDetail.Remark
          item.IsEdit = 1
        }
      })
      this.remarkDialog = false
    },

    // 筛选
    filterData(room) {
      this.currentPage = 1
      this.roomArr = room
    },

    // 分页
    handleCurrentChange(size) {
      this.currentPage = size
      this.$nextTick(() => {
        document.getElementById('lv-list0').scrollIntoView(false)
      })
    }
  }
}
</script>

<style scoped>
.one-implement {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.one-implement-head {
  width: 100%;
  box-sizing: border-box;
  z-index: 1;
  padding: 15px 15px 0px 15px;
  background: #fff;
}

.no-header {
  top: 48px !important;
}
.no-header1 {
  top: 150px !important;
}
.implement-image {
  width: 42px;
  height: 42px;
  border-radius: 21px;
  margin-right: 7px;
  border: 1px solid #029fd1;
  /* box-shadow: 0px 0px 10px 0px #888888; */
}
.one-implement-top {
  display: flex;
}
.implement-row {
  display: flex;
  justify-content: space-between;
}
.implement-list {
  flex: 1;
  overflow-y: auto;
}
.name {
  font-size: 16px;
  font-weight: 500;
  color: #0a0e10;
  margin-right: 5px;
  font-family: 'PingFang SC Medium';
}
.level {
  font-size: 12px;
  font-weight: 400;
  color: #7c7e80;
  margin-right: 25px;
}
.room {
  font-size: 12px;
  font-weight: 400;
  color: #029fd1 !important;
}
.implement-message {
  display: flex;
  align-items: center;
}
.implement-num {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #f32e2f;
}
.implement-all-check {
  margin-right: 4px;
}
.implement-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 15px;
  background: #fff;
  box-sizing: border-box;
}
.implement-item {
  margin: 4px 12px 12px 12px;
  padding: 12px;
  background: #fff;
  border-radius: 8px;
}
.line {
  width: 100%;
  height: 1px;
  background: #ebebeb;
}
.time {
  padding-bottom: 20px;
  font-size: 12px;
  font-weight: 500;
  color: #434649;
}
.btn-list {
  display: flex;
  align-content: center;
  margin-left: auto;
}
.all-btn {
  font-size: 12px;
  width: 67px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  border-radius: 2px;
  box-sizing: border-box;
}
.all-cancel {
  background: #dcf7ff;
  color: #029fd1;
  border: 1px solid #029fd1;
}
.all-sure {
  background: #029fd1;
  color: #ffffff;
  margin-left: 15px;
}
.implement-row {
  font-size: 16px;
  width: 100%;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  background: #f7f8fa;
  box-sizing: border-box;
  z-index: 1;
}
.already-implement,
.not-implement {
  position: relative;
  width: 168px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  background-color: #dcf7ff;
  color: #029fd1;
}
.already-implement::after {
  position: absolute;
  right: -12px;
  top: 0;
  width: 0;
  height: 0;
  border-top: 36px solid #dcf7ff;
  border-right: 12px solid transparent;
  content: '';
}
.not-implement::after {
  position: absolute;
  left: -12px;
  top: 0;
  width: 0;
  height: 0;
  border-bottom: 36px solid #dcf7ff;
  border-left: 12px solid transparent;
  content: '';
}
.active-implement {
  background-color: #029fd1;
  color: #fff;
}
.active-implement::after {
  border-top-color: #029fd1;
  border-bottom-color: #029fd1;
}

.task-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px 0;
}
.task-container .task {
  font-size: 16px;
  font-weight: 500;
  line-height: 23px;
  color: #029fd1;
}
.task-container .img {
  width: 26px;
  height: 26px;
}
.footer .img {
  width: 26px;
  height: 26px;
}
.footer .img-check {
  margin-right: 15px;
}

.handle-btn {
  display: flex;
  justify-content: space-between;
}

/* 备注弹框 */
.dialog >>> .el-dialog {
  width: 345px !important;
}
.dialog >>> .submit {
  background: #029fd1;
  border-color: #029fd1;
}
.select-button {
  width: 69px;
  height: 32px;
  font-size: 14px;
  margin: 5px 12px 5px 0px !important;
  padding: 6px;
  color: #029fd1 !important;
  border-color: #029fd1 !important;
}
.select-button:nth-child(4n) {
  margin-right: 0px !important;
}
.implement-remark >>> .el-dialog {
  border-radius: 5px;
}
.implement-remark >>> .el-dialog__header {
  height: 0px;
  padding: 0px;
}
.implement-remark >>> .el-dialog__body {
  padding: 14px 16px;
}
.message,
.name,
.task {
  font-weight: 500;
  font-family: 'PingFang SC Medium';
}
.message {
  position: relative;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  line-height: 22px;
  color: #0a0e10;
  text-indent: 7px;
}
.message::before {
  position: absolute;
  top: 3px;
  left: 0px;
  content: '';
  display: block;
  width: 4px;
  height: 17px;
  background: #029fd1;
  border-radius: 150px;
}
.close-image {
  width: 16px;
  height: 16px;
  padding-right: 7px;
}
.task-name {
  display: flex;
  justify-content: space-between;
  margin: 20px 0px;
}
.task-container,
.avatar-container {
  display: flex;
  align-items: center;
}

.task-container {
  font-size: 16px;
  color: #029fd1;
}
.task-image {
  margin-right: 3px;
  width: 24px;
  height: 24px;
}
.avatar-container {
  font-size: 14px;
  color: #0a0e10;
}
.avatar-image {
  margin-right: 7px;
  width: 34px;
  height: 34px;
  border-radius: 17px;
  border: 1px solid #029fd1;
  box-sizing: border-box;
}
.illustrate {
  font-size: 14px;
  margin: 8px 0px;
  color: #0a0e10;
  font-family: 'PingFang SC Medium';
}
.textarea {
  font-weight: 400;
  color: #0a0e10;
  font-size: 12px;
}
.textarea >>> .el-textarea__inner {
  width: 100%;
  height: 190px;
  background: #e9f7fb;
  border-radius: 4px;
  padding: 12px !important;
  outline: none;
  border: none;
}
.submit {
  float: right;
  width: 69px;
  height: 32px;
  line-height: 8px;
  font-size: 14px;
  margin-top: 28px;
}
.dialog-footer::after {
  content: '';
  display: block;
  clear: both;
}
.input {
  margin-bottom: 10px;
  width: 315px;
  height: 32px;
  background: #f4f4f4;
  border-radius: 2px;
}
.input >>> .el-input__inner {
  width: 315px;
  height: 32px;
  background: #f4f4f4;
  border-radius: 2px;
  font-size: 12px;
}
.dialog >>> .el-button--primary.is-plain:hover {
  background: rgba(6, 160, 209, 0.15);
  color: #029fd1;
  border-color: #b3d8ff;
}
.active-buton {
  background: #029fd1 !important;
  color: #fff !important;
}

.result {
  display: flex;
  /* align-items: center; */
}
.result .img {
  width: 17px;
  height: 17px;
}
.result .remark {
  margin-top: 0.08rem;
  font-size: 0.533333rem;
  color: #434649 !important;
}

.pagination {
  width: 100%;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/cure/execute.vue